<!--首页-->
<template>
  <div class="home-page-container">
    <div ref="topScrollWrapperRef">
      <banner-swiper />
      <notice-bar />
    </div>
    <game-category-menu :top-height="height" />
    <lobby />
    <!-- <ranking v-if="isRecommend" /> -->
    <website-info />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { storeToRefs, useGameStore } from '@star/stores';
import { toNumber } from 'lodash-es';
import NoticeBar from './components/NoticeBar.vue';
import BannerSwiper from './components/BannerSwiper.vue';
import GameCategoryMenu from './components/GameCategoryMenu.vue';
import Lobby from './components/Lobby.vue';
import WebsiteInfo from './components/WebsiteInfo.vue';
import { GameMainTypesEnum } from '@star/constants';
import { useElementSize } from '@vueuse/core';
import { emitter, EventEnum } from '@star/utils';

const gameStore = useGameStore();
const { activeHomeMainMenuTab } = storeToRefs(gameStore);
const topScrollWrapperRef = ref(null);
const { height } = useElementSize(topScrollWrapperRef);

// 是否推荐菜单
const isRecommend = computed(() => {
  return toNumber(activeHomeMainMenuTab.value) === GameMainTypesEnum.RECOMMEND;
});

watch(
  () => height.value,
  value => {
    emitter.emit(EventEnum.HOME_PAGE_TOP_HEIGHT, value);
  }
);
</script>

<style lang="less" scoped>
.home-page-container {
  background-color: var(--theme-app-backgroud-color);
  padding-bottom: 100px;

  :deep(.van-image__error) {
    background-image: linear-gradient(#f4f4f4, #b8b8b8);
  }

  :deep(.items-lottery) {
    .van-image__error {
      border-radius: 60px;
      background: #c2c2c2;
      height: 88%;
    }
  }
}
</style>
